/**
 * Context for managing pane-specific routing state
 */

import type { PaneRouterContextValue } from "@/types/pane-routing";
import { createContext, useContext } from "react";

export const PaneRouterContext = createContext<PaneRouterContextValue | null>(
  null,
);

/**
 * Hook to get the current pane router context
 * Throws an error if used outside of a PaneRouter
 */
export function usePaneRouterContext(): PaneRouterContextValue {
  const context = useContext(PaneRouterContext);

  if (!context) {
    throw new Error("usePaneRouterContext must be used within a PaneRouter");
  }

  return context;
}

/**
 * Hook to safely get the pane router context (returns null if not within a PaneRouter)
 */
export function usePaneRouterContextSafe(): PaneRouterContextValue | null {
  return useContext(PaneRouterContext);
}
